import Tippy from '@tippyjs/react';
import {followCursor} from 'tippy.js';
import * as styles from './tooltip.module.css';

interface ITooltipProps {
    children: JSX.Element,
    text: string,
    hideOnClick?: boolean,
    disabled?: boolean,
}

const Tooltip = ({
    children,
    text,
    hideOnClick = false,
    disabled = false,
}: ITooltipProps) => (
    <Tippy
        content={text}
        followCursor={true}
        placement="bottom-start"
        plugins={[followCursor]}
        offset={[10, 20]}
        className={styles.tooltip}
        duration={[200, 50]}
        hideOnClick={hideOnClick}
        disabled={disabled}
    >
        <span className={styles.spanWrapper}>
            {children}
        </span>
    </Tippy>
);

export default Tooltip;
